module.exports = "/static/assets/a23ddf472c2139e0c0361f74eb4da16e.png";